import { Handle, type NodeProps, NodeResizer, Position } from '@xyflow/react';

type FlowData = { label: string; isEditMode?: boolean };

export function ProcessFlowNode({ data, selected }: NodeProps) {
  const d = data as FlowData;
  return (
    <div
      className={`relative flex h-full w-full min-h-0 min-w-0 flex-col items-center justify-center rounded-md border bg-white px-3 py-2 text-center text-[13px] font-semibold text-slate-800 shadow-[0_2px_4px_rgba(0,0,0,0.1)] ${
        selected
          ? 'border-sky-500 shadow-[0_0_0_1px_#0096FF,0_2px_4px_rgba(0,0,0,0.1)]'
          : 'border-slate-200'
      }`}
    >
      {d.isEditMode ? (
        <NodeResizer
          color="#2563eb"
          isVisible
          minWidth={100}
          minHeight={48}
          maxWidth={720}
          maxHeight={400}
        />
      ) : null}
      <span className="max-w-full break-words">{d.label}</span>
      <Handle
        type="target"
        position={Position.Left}
        id="target"
        className="!top-1/2 !h-3 !w-3 !-translate-y-1/2 !border-2 !border-white !bg-[#28a745]"
      />
      <Handle
        type="source"
        position={Position.Right}
        id="source"
        className="!top-1/2 !h-3 !w-3 !-translate-y-1/2 !border-2 !border-white !bg-[#007bff]"
      />
    </div>
  );
}
